import { CULTURALPRETEMSUCCESS, CULTURALPRETEMFAIL } from "../actionTypes";
const initialState = {
  getTemp: [],
};
const getculturePreBuiltTemplateReducer = (state = initialState, action) => {
  switch (action.type) {
    case CULTURALPRETEMSUCCESS:
      return {
        ...state,
        getTemp: action.payload,
      };
    case CULTURALPRETEMFAIL:
      return {
        ...state,
        getTemp: null,
      };
    default:
      break;
  }
  return state;
};
export default getculturePreBuiltTemplateReducer;
